export default "__VITE_ASSET__MAXOeW1U__"